/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect,useRef,useContext } from 'react'
import '../../../assets/styles/styles.scss'
import '../../../assets/styles/inner/table.scss'
import deleteIcon from "../../../assets/delete.svg";
import { IoIosRemoveCircle } from "react-icons/io";
import {Loading,Modal,EditModal,DeleteConf} from '../../../common';
import { FaEdit } from "react-icons/fa";
import {parseJwtToken} from '../../../utils/commonFunctions.js';
import AllMultiSelect from "../../../common/AllSelectCheckbox.jsx";
import { APIEndpoint} from "../../../utils/axios";
import searchIcon from '../../../assets/icons/search.svg';
import { components } from "react-select";
import CustomSelect from "../../../common/CustomSelect";
import { customSelSearch } from '../../../utils/configs.js';
import { useTranslation } from 'react-i18next'
import {ThemeContext} from "../../../contexts/themeContext";

const EditFormFieldsDom = [
  {label: 'Code', attribute: 'code', type: 'text', disabled: false, required: true },
  {label: 'Name', attribute: 'name', type: 'text', disabled: false,required: true},
  {label: 'Description', attribute: 'description', type: 'textarea', disabled: false, required: true},
];

export const ManageUserRolesPage = () => {
  const { ready} = useTranslation();
  const [userRoles,setUserRoles]=useState([]);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const EditFormFieldsUSerPerm = [
    {label: 'User', attribute: 'user', type: 'selectSearch2', disabled: false,options: userRoles,required: true },
     {label: 'Assignment Type', attribute: 'assignmentType', type: 'text', disabled: false,required: true},
    {label: 'Role', attribute: 'role',  type: 'text', disabled: false, required: true},
    {label: 'Resource', attribute: 'resource', type: 'text', disabled: false, required: true},
    {label: 'Action', attribute: 'action',  type: 'text', disabled: false, required: true},
  ];
  const [editFieldsRolesPerm] = useState(EditFormFieldsDom);
const [editFieldsRolesUserPerm] = useState(EditFormFieldsUSerPerm);
const [editFieldsInt] = useState([]);
  const [addRole,setAddRole]=useState(null);
  const [userPolicies,setUserPolicies]=useState([]);
  const [userResources,setUserResources]=useState([]);
  const [userActions,setUserActions]=useState([]);
  const [userResourcesAll,setUserResourcesAll]=useState([]);
  const [showDescription,setShowDescription]=useState(false);
  const [editFieldsCess]=useState([]);
  const [newRoles,setNewRoles]=useState({});
  const [roleArray,setRolesArray] =useState([]);
  const [addedItems,setAddedItems]=useState([]);
  const [roleSelection,setRoleSelection]=useState(null);
  const [deleteRefresh,setDeleteRefresh]=useState(false);
  const [modalTitle] = useState("Edit Details");
  const [modalCustomButtons] = useState(null);
  const [modalFormStatusObj,setModalFormStatusObj] = useState({ text: '' });
  const [state, setState] = useState({descriptionItem:""});
  const [searchKey,setSearchKey] =useState("");
  const [buttonStatus,setButtonStatus]=useState(false);
  const [showIntLoading,setShowInitLoading] =useState(true);
  const [disabledAction, setDisabledAction] = useState(true);
  const [actionEdit,setActionEdit]=useState(false);
  const [permissionsMain, setPermissionsMain] = useState([]);
  const [isDropDownOpen,setIsDropdownOpen]=useState(false);
  const [ModalContHeight,setModalContHeight]=useState({height:'auto'})
  const [noResult, setNoResult] = useState(false);
  const [selectedActions, setSelectedActions] = useState({})
  const [loadingMessage,setloadingMessage] =useState("Please wait...");
    const {themedColor} = useContext(ThemeContext);

const itemDesc=useRef(0);
const loadingTimeRef=useRef(null);
const userRole = localStorage.getItem('userRole');
const permissions = localStorage.getItem("userPermissions");

  const sectorTitle=()=>{
    const {type}=state;
    if(type==='roles'||type==='rolesEdit'){
      const { selected } = state;
  return(<div className={selected?.mode === 'edit' ? 'flexRow justifyContentCenter' : 'flexRow justifyContentSpaceBetween'}>
        <div className='flexRow justifyContentFlexStart m-2'>{`${selected?.mode==='edit'?`Add Resource - ${selected.role.name??""}`:"Add Role Permission"}`}  </div>
        {type!=='rolesEdit'?<div className="flexRow justifyContentFlexEnd margRight30">
            <button className="add-item-button" onClick={ ()=>handleEdit(selected.id,'roleAdd') }>
                 + Role
                  </button>
            </div>:null}

    </div>
)
    }
    if(type==='viewResPermission'){
      const { selected } = state;
      return(<div className='flexRow justifyContentCenter'>
      <div className='flexRow justifyContentCenter alignItemsCenter'>Edit {selected.description?.replace("Permission","Permissions").slice(0,-1)} for <div className='instance-member-name'>{selected.roleName??""}</div></div>
      </div>
      )
    }
    else{
      return(<></>)
    }

  }

  React.useEffect(() => {
    if(isDropDownOpen){
      setModalContHeight({height:'55vh'})
    }else{
      setModalContHeight({height:'auto'})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [isDropDownOpen]);

useEffect(() => {
  getUserPolicies();
}, [deleteRefresh])

useEffect(() => {
  const initializePermissions = () => {
    if (userRole && permissions) {
      const permissionsObject = JSON.parse(permissions);
      const rolePermissions = permissionsObject[userRole];
      setPermissionsMain(rolePermissions)
    }
  };

  initializePermissions();
}, [userRole, permissions]);


useEffect(() => {
if(userPolicies.length){
  let options=[];
  userPolicies.forEach((item,index)=>{
   const roleSel= item.role && typeof item.role!=='string'?item.role?.name:item.role
    options.push({key:index,label:roleSel,value:roleSel})
  })
setRolesArray(options)
}
if(loadingTimeRef.current && userPolicies.length){
  clearTimeout(loadingTimeRef.current);
}
loadingTimeRef.current = setTimeout(()=>{
setloadingMessage("No Data");
},5000)
}, [userPolicies]);

useEffect(() => {
  let timeout;
  if(!roleSelection){
    timeout= setTimeout(() => {
    clearTimeout(timeout);
      setShowInitLoading(false);
  }, 2100);
  }
  }, [roleSelection])

useEffect(() => {
  if(state.descriptionItem.length){
  setShowDescription(true);
const timeOut=setTimeout(() => {
  clearTimeout(timeOut);
  setShowDescription(false);
  setState((_)=>({..._,descriptionItem:""}));
}, 3800);
  }else{
    setShowDescription(false);
  }
}, [state.descriptionItem])

useEffect(() => {
  if (Object.keys(newRoles)?.length!==3) {
    setDisabledAction(true);
  } else {
    setDisabledAction(Object.values(newRoles).some(value => value === ""));
  }
}, [newRoles]);

useEffect(() => {
if(modalFormStatusObj.text||modalFormStatusObj.error){
  let timeout
  timeout=setTimeout(() => {
    clearTimeout(timeout);
    setModalFormStatusObj({text:''})
  }, 1200);
}
}, [modalFormStatusObj]);

useEffect(() => {
let changedItems="";
changedItems=itemDesc.current<addedItems.length?addedItems[addedItems.length-1].desc:"";
setState((_)=>({..._,descriptionItem:changedItems}));
itemDesc.current=addedItems.length;
}, [addedItems]);

useEffect(() => {
const ele=document.getElementById('resource-fields')
if(ele &&  ele?.innerHTML?.length){
  const htmlContent = ele.innerHTML;
  htmlContent.includes('No Result')?setNoResult(true):setNoResult(false);
}
}, [searchKey])

 function clearNulls(resAr){
  try{
    return resAr.filter(src=>src);
  }
  catch(e){
    return []

  }
}

  const handleCheckboxChange = (actionKey, isChecked) => {
    setSelectedActions((prev) => ({
      ...prev,
      [actionKey]: isChecked,
    }));
  };

async function getUserPolicies(){
   try {
     const[res,res1,res2,res3]= await Promise.all([
        APIEndpoint.get('authz/policies'),
        APIEndpoint.get('authz/resources'),
        APIEndpoint.get('authz/actions'),
        APIEndpoint.get('authz/roles')
      ]);
    if(res && res.items && res.items.length && res1 && res1.items.length && res2 && res2.items.length && res3 && res3.items.length){
      setUserPolicies(clearNulls(res.items));
      setUserResourcesAll(clearNulls(res1.items));
      setUserResources(()=>{
        return clearNulls(res1.items).map((item,index)=>({key:index,label:item.name,value:item.code,desc:item.description}))
      });
      setUserActions(()=>{
        return clearNulls(res2.items).map((item,index)=>({key:index,label:item.name,value:item.code}))
      });
      setUserRoles(()=>{
        return clearNulls(res3.items).map((item,index)=>({key:index,label:item.name,value:item.code}))
      });
    }
    } catch (error) {

    }
}

function handleEdit(rn,type){

    if(type==='roles'|| type==='rolesEdit'){
        const editPer = userPolicies.find((item) => item.role.code === rn?.code);
        let resRcOpt=[];
        if(editPer){
         
      setState((prev) => ({
  ...prev,
  type: type,
  selected: {
    ...editPer,
    ...(type === 'rolesEdit'
      ? {
            resourcesEdit: editPer.resources.map((rs, index) => ({
            key: index,
            label: rs.name,
            value: rs.code,
            description: rs.description,
          })),
        }
      : {}),
    mode: type === 'roles' ? 'remove' : 'edit',
  },
}));

        }else{
        setState((_)=>({..._,type:type,selected:{mode:'add',resourcesEdit:[],resourcesOg:resRcOpt,actions:[],effects:['allow']}}));

        }

    }

    else if(type==='roleAdd'){
        setState((_)=>({..._,type:type,selected2:true}));
    }else{}

}



function onAddRoleChange(e){
  setAddRole(e);
}
function onSearch(e){
setSearchKey(e.target.value)
}

function handleChangeRsources(sel){
  const {resourcesOg,mode}=state.selected;
  if(mode!=='edit'){
   setAddedItems(()=>{ return sel.filter(item =>
    !resourcesOg.some(prevItem => prevItem.label === item.label)
  )});
  }
  setState((_)=>({..._,selected:{..._.selected,resourcesEdit:userResources.filter((item,index)=>sel.some((itemSel,index)=>itemSel.label===item.label))}}))
}
function handleChangeActions(sel){
  setState((_)=>({..._,selected:{..._.selected,actions:userActions.filter((item,index)=>sel.some((itemSel,index)=>itemSel.label===item.label))}}))
}

const Option = props => {
    return (
    <div>
    <components.Option {...props}>
    <input
    type="checkbox"
    checked={props.isSelected}
    onChange={() => null}
    />{" "}
    <label>{props.label}</label>
    </components.Option>
    </div>
    );
    };

  const MultiValue = props => (
    <components.MultiValue {...props}>
    <span>{props.data.label}</span>
    </components.MultiValue>
    );

    const onFieldChangeHandler = (e) => {
      setModalFormStatusObj({text:''});

      const {name,value}=e.target;
      setNewRoles((_)=>({
        ..._,
        [name]:value
      }))


    };

function handleActionsView(cd,actionType=null){
 if(actionType==='edit'){
   const arrayMain= Object.keys(permissionsMain).slice(1);
   const actionsIndividual= arrayMain.map(key=>({[key]:cd.selected.actions.includes(key)}))
   
     setState((_)=>({..._,type:'viewResPermission',selected:{...cd.selected,data:actionsIndividual}}))
 }
 else{
  setState((_)=>({..._,selected:{mode:'removeResource',...cd.selected}}))
 }
}

const showResourcesFields = (rSrc) => {
  if (!Array.isArray(rSrc.resourceIn) || rSrc.resourceIn.length === 0) {
    return null;
  }

  return rSrc.resourceIn
    .filter(itemEx => itemEx)
    .map((item, index) => (
      <div
        title={`${item.name}`}
        key={index}
        className="rolesn-labl"
        onMouseEnter={() => setHoveredIndex(index)}
        onMouseLeave={() => setHoveredIndex(null)}
      >
        <span className={index === 0 ? "sector-label-minGrid margSecotInit" : "sector-label-minGrid"}>
          {item.name ?? ""}
        </span>

        {hoveredIndex === index && (
          <div className="icon-container">
            <FaEdit
              className="icon edit-icon"
              title="Edit Resource"
              onClick={() =>
                handleActionsView(
                  { selected: { ...item, roleName: rSrc.roleName, roleCode: rSrc.roleCode } },
                  "edit"
                )
              }
            />
            <IoIosRemoveCircle
              className="icon delete-icon"
              title="Remove Resource"
              onClick={() =>
                handleActionsView(
                  { selected: { ...item, roleName: rSrc.roleName, roleCode: rSrc.roleCode } },
                  "removeResource"
                )
              }
            />
          </div>
        )}
      </div>
    ));
};
function validationCheck(data){
  if(!data)return;
  if (data?.role === "") {
    return false;
}
if (Array.isArray(data?.actions) && data.actions?.length === 0) {
    return false;
}
if (Array.isArray(data?.resources) && data.resources?.length === 0) {
    return false;
}
if (Array.isArray(data?.effects) && data?.effects.every(effect => effect === "")) {
    return false;
}

return true;
}

async function onSubmit(){
 const {actions,resourcesEdit,mode}=state?.selected;

if(mode && mode!=='edit'){
  if(!resourcesEdit?.length){
  setModalFormStatusObj({error:'Please select the required fields'});
   return;
  };
   const updatedRoles=[{roleName:addRole.value,actions:actions?.map(item=>item.value),resources:resourcesEdit?.map(rsc=>rsc?.value),effect:'allow'}];
 
   if(validationCheck(updatedRoles)){
     setDisabledAction(true);
   try {
     const res=await APIEndpoint.post('authz/policies',updatedRoles);
     if(res){
       setModalFormStatusObj({text:res.message||'Successfully Added Policies'});
       handleReset();
     }
   } catch (error) {
     const err=JSON.parse(error.message);
     setModalFormStatusObj({error:err?.data?.message||'Error Adding Policies'});
 
   }finally{
     setDisabledAction(false);
   }
   }
}else if(mode==='edit'){
  if(!resourcesEdit.length){
    setModalFormStatusObj({error:'Please select the required fields'});
    return;
  }else{
    const {effect,role,actions,resources}=state.selected;
    const editedResources = userResourcesAll.filter(ur=>resourcesEdit.some(red=>red.value===ur.code)).map(ed=>({...ed,type:'resource'}));

  const defaultActions = ["finalize", "print", "reject", "approve","upload", "download", "delete", "edit", "create", "view"];

const resourceWithActions = editedResources.map(er => {
  const matchedResource = resources.find(rc => rc.code === er.code);
  const actions = matchedResource ? matchedResource.actions : defaultActions;
  return { ...er, actions };
});

    try {
      const res=await APIEndpoint.put('authz/policies',{role,resources:resourceWithActions,effect,actions});
      if(res){
        setModalFormStatusObj({text:res.message||'Successfully Updated Role Policies'});
        handleReset();
      }
    } catch (error) {
      const err=JSON.parse(error.message);
      setModalFormStatusObj({error:err?.data?.message||'Error Updating Policies'});
  
    }finally{
      setDisabledAction(false);
    }
  }
}

}


function handleReset() {
  setTimeout(() => {
    const isRoleUpdated = state?.type === 'roles' && state?.selected?.mode;
    setModalFormStatusObj({ text: "" });
    setButtonStatus(false);
    setRoleSelection(null);
    setUserPolicies([]);
    setRolesArray([]);
    setDeleteRefresh(prev => !prev);
    if (isRoleUpdated) {
      setState(prev => ({ ...prev, selected: false }));
    }
      setDisabledAction(false);
      if(state.selected.mode==='edit'){
      onCloseEditMeals('edit');
      }
      else if(state.type==='viewResPermission'|| (state.selected && state.selected.mode==='removeResource')){
          onCloseEditMeals('');
      }
      else{
        onCloseEditMeals('roleAdd');
      }
      setNewRoles({});
      setAddRole(null);

  }, 2000);
}
const handleMenuOpen = () => {
    setIsDropdownOpen(true); 
};
const handleMenuClose = () => {
   setIsDropdownOpen(false); 
};

async function onSubmitNewRoles(){
  if (!disabledAction) {
    try {
      setDisabledAction(true);
      const res=await APIEndpoint.post('authz/roles',newRoles);
      if(res){
      setModalFormStatusObj({text:res.message||'Roles Added Successfully'});
      handleReset();
      }
    } catch (error) {
      const err=JSON.parse(error.message);
    setModalFormStatusObj({error:err?.data?.message||"Failed to save"});
    }finally{
      setDisabledAction(false);
    }

  }else{
    setModalFormStatusObj({error:'Please Provide all the required fields'})
  }
}

const onCloseEditMeals=async(type)=>{

    if(type==='roleAdd'){
    setState((_)=>({..._,type:'roles',selected2:false}));
    setNewRoles({});
    }
    
   else if (
  type === 'viewResPermission' &&
  Object.keys(selectedActions).length > 0 &&
  state?.selected
) {
  const { selected } = state;
  const { actions = [], roleCode, code } = selected;

  const result = { delete: [], edit: [] };

  for (const [key, value] of Object.entries(selectedActions)) {
    if (actions.includes(key) && value === false) {
      result.delete.push(key);
    } else if (!actions.includes(key) && value === true) {
      result.edit.push(key);
    }
  }

  if (result.delete.length === 0 && result.edit.length === 0) {
    setActionEdit(false);
    return;
  }

setActionEdit(true);
  if (result.edit.length > 0) {
    const updatedActions = [
      {
        roleName: [roleCode],
        actions: result.edit,
        resources: [code]
      }
    ];

    try {
      const res = await APIEndpoint.post('authz/policies', updatedActions);
      if (res) {
        setModalFormStatusObj({
          text: res.message || 'Successfully Edited Actions.'
        });
        handleReset();
      }
    } catch (error) {
      console.error('Failed to add policies:', error);
      setModalFormStatusObj({ error: 'Failed to Add Policies' });
    }
  }


  if (result.delete.length > 0) {
    try {
      const storedCreds = localStorage.getItem('login_credentials');
      if (!storedCreds) return;

      const parsedCreds = JSON.parse(storedCreds);
      const { data, headers } = parsedCreds || {};
      const tokenResp = await parseJwtToken(data);

      if (
        !tokenResp?.userId ||
        !data?.token ||
        !headers?.['x-csrf-token']
      )
        return;

      const requestHeaders = {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=utf-8',
        user_id: tokenResp.userId,
        'X-Bearer-Token': data.token,
        'X-Csrf-Token': headers['x-csrf-token']
      };

      let allSuccess = true;
      let errors = [];

 
        const body = {
          role: roleCode,
          resource: [code],
          action: result.delete, 
          effect: 'allow'
        };

        const response = await fetch(
          APIEndpoint.getFullPath('authz/policies'),
          {
            method: 'DELETE',
            body: JSON.stringify(body),
            headers: requestHeaders
          }
        );

        if (!response.ok) {
          allSuccess = false;
          const errorMsg = await response.json();
          errors.push(errorMsg?.message || `Failed to delete`);
        }
      

      if (allSuccess) {
        setModalFormStatusObj({ text: 'Successfully Removed Action(s)' });
      } else {
        setModalFormStatusObj({
          error: errors.join('\n') || 'Some deletions failed'
        });
      }

      setDisabledAction(false);
    } catch (err) {
      let parsedError = {
        data: { message: 'An unexpected error occurred' }
      };

      try {
        parsedError = JSON.parse(err?.message);
      } catch (parseError) {
        console.error('Failed to parse error message:', parseError);
      }

      setModalFormStatusObj({
        error: parsedError?.data?.message || 'Failed to Delete Action(s).'
      });

      setDisabledAction(false);
    } finally {
      handleReset();
    }
  }
setActionEdit(false);

}else if(type==='removeResource'){
  const { selected } = state;
  const { actions = [], roleCode, code } = selected;

  try {
    const storedCreds = localStorage.getItem('login_credentials');
    if (!storedCreds) return;

    const parsedCreds = JSON.parse(storedCreds);
    const { data, headers } = parsedCreds || {};
    const tokenResp = await parseJwtToken(data);

    if (
      !tokenResp?.userId ||
      !data?.token ||
      !headers?.['x-csrf-token']
    )
      return;

    const requestHeaders = {
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=utf-8',
      user_id: tokenResp.userId,
      'X-Bearer-Token': data.token,
      'X-Csrf-Token': headers['x-csrf-token']
    };

    let allSuccess = true;
    let errors = [];


      const body = {
        role: roleCode,
        resource: [code],
        action: actions, 
        effect: 'allow'
      };

      const response = await fetch(
        APIEndpoint.getFullPath('authz/policies'),
        {
          method: 'DELETE',
          body: JSON.stringify(body),
          headers: requestHeaders
        }
      );

      if (!response.ok) {
        allSuccess = false;
        const errorMsg = await response.json();
        errors.push(errorMsg?.message || `Failed to delete`);
      }
    

    if (allSuccess) {
      setModalFormStatusObj({ text: 'Successfully Removed Action(s)' });
    } else {
      setModalFormStatusObj({
        error: errors.join('\n') || 'Some deletions failed'
      });
    }

    setDisabledAction(false);
  } catch (err) {
    let parsedError = {
      data: { message: 'An unexpected error occurred' }
    };

    try {
      parsedError = JSON.parse(err?.message);
    } catch (parseError) {
      console.error('Failed to parse error message:', parseError);
    }

    setModalFormStatusObj({
      error: parsedError?.data?.message || 'Failed to Delete Action(s).'
    });

    setDisabledAction(false);
  } finally {
    handleReset();
  }

}

    else {
      setAddRole(null);
      setAddedItems([]);
      setSelectedActions({});
        setState((_)=>({..._,selected:false}));
    }

}
function onRolesChange(e){
  setRoleSelection(e);
}

async function onDeleteRole() {
  try {
    const storedCreds = localStorage.getItem('login_credentials');
 
    if (!storedCreds) return;

    let loginCred;
    try {
      loginCred = JSON.parse(storedCreds);
    } catch (parseError) {
      console.error('Failed to parse stored credentials:', parseError);
      return;
    }
    const { data, headers } = loginCred || {};
       const tokenResp = await parseJwtToken(data);
    if (!tokenResp?.userId || !data?.token || !headers?.['x-csrf-token']) return;
    const selected = state?.selected;

    if (!selected) return;

    const { role } = selected;

    if (!role) return;
    setDisabledAction(true);
    let body = {
     roleName:(typeof role==='string')?role:role.code,
    };

    const requestHeaders = {
      'Accept': 'application/json',
      'Content-Type': 'application/json; charset=utf-8',
      'user_id': tokenResp.userId,
      'X-Bearer-Token': data.token,
      'X-Csrf-Token': headers['x-csrf-token']
    };


    const response = await fetch(APIEndpoint.getFullPath('authz/roles/policies'), {
      method: 'DELETE',
      body: JSON.stringify(body),
      headers: requestHeaders
    });

    if (response.ok) {
      const resData = await response.json();
      setModalFormStatusObj({ text: resData?.message || 'Successfully Deleted Role' });
      setDisabledAction(false);
    } else {
      const errorMsg = await response.json();
      setModalFormStatusObj({ error: `${errorMsg?.message??'Failed to Delete Role'}` });
      setDisabledAction(false);
    }
  } catch (err) {
    let parsedError;
    try {
      parsedError = JSON.parse(err?.message);
    } catch (parseError) {
    setDisabledAction(false);
      console.error('Failed to parse error message:', parseError);
      parsedError = { data: { message: 'An unexpected error occurred' } };
    }
    setModalFormStatusObj({ error: parsedError?.data?.message || 'Failed to Delete Role' });
  } finally {
    handleReset();
  }
}

const delProps={onCloseDelete:() => onCloseEditMeals('roles'),onContinue:() => onDeleteRole(),buttonStat:buttonStatus};
const delPropRes={onCloseDelete:() => onCloseEditMeals('roles'),onContinue:() =>  onCloseEditMeals(state.selected.mode??""),buttonStat:buttonStatus};
  return (
    <div className='op-aircraft-container flexCol full-flex ag-theme-alpine-dark'>
     {
        <>
<div className="flexRow row justifyContentSpaceBetween">
    <div className='flexRow justifyContentSpaceAround margBottom18'>
      <div className="width100">
        <div className="flexRow width100 margBot10 justifyContentSpaceBetween">
             <div className='flexRow justifyContentFlexStart' style={{zIndex:2}}>
                <div className='margRight10' >
                <CustomSelect
                options={roleArray}
                width={'12rem'}
                value={!roleSelection ? null : roleArray?.find(function(option) {
                return roleSelection && roleSelection?.value && roleSelection.value === option.label
                })}
                placeHolder=" Search Role..."
                onChange={onRolesChange}
                />
                </div>
                </div>
          <div className="flexRow justifyContentCenter alignItemsCenter width100 content-tabs">
            <div className="margLeft margBot10 margTop8 underline">
              <span><img className="icon-size" alt={'Search'} src={searchIcon} /></span>
              <span><input className="search" onChange={onSearch} value={searchKey} type="search" placeholder="Search resources" /></span>
            </div>
          </div>
          <div className="flexRow justifyContentFlexEnd alignItemsBaseline content-tabs">
            <button className="add-item-button" onClick={(e) => {e.stopPropagation(); handleEdit(null, 'roles')}}>
              + Role Permission
            </button>
          </div>
        </div>

        <div className='table-header'></div>
        <div className='zero-scroll-in' style={{maxHeight:'calc(100vh - 20px)',overflowY: 'auto',marginBottom:'2vh',scrollbarWidth:'none'}}>
          <table id='rolesTable' style={{width: '100%'}}  className="custom-table">
            <thead>
              <tr className="sticky2 table-header">
                <th style={{ textAlign: 'center', width: '10%', whiteSpace: 'nowrap' }}>Role</th>
                <th style={{ textAlign: 'center', width: '80%', whiteSpace: 'nowrap' }}>Resources</th>
                <th style={{ textAlign: 'center', width: '10%', whiteSpace: 'nowrap' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
                 {userPolicies.length > 0 ? (
  (roleSelection ? 
    userPolicies.filter(pol => {
      const roleName = typeof pol.role === 'string' ? pol.role : pol.role?.name;
      return roleName === roleSelection.value;
    }) 
    : [
  ...userPolicies,
  ...Array.from({ length: 4 }, () => ({
    role: null,
    resources: []
  }))
]
  ).map((role, index) => {
    const roleName = typeof role.role === 'string' ? role.role : role.role?.name;
    const roleCode = typeof role.role === 'string' ? role.code : role.role?.code;

    

    return (
      <tr key={index} className={!Number(index % 2) ? "tableEvenRowClass" : "tableRowClass"} style={{ color: "#fff" }}>
        <td style={{ whiteSpace: 'nowrap',height:'38px' }}>{roleName}</td>
        <td id='resource-fields' style={{ minHeight: '15vh' }}>
          {showResourcesFields({resourceIn:role.resources,roleName,roleCode})}
        </td>
        <td style={{ whiteSpace: 'nowrap' }}>
          {!noResult && role?.role ? (
            <div className='flexRow justifyContentCenter alignItemsCenter'>
              <img
                className='icon-size-role-del'
                alt='delete'
                title='Remove Role'
                onClick={() => handleEdit(role.role, 'roles')}
                src={deleteIcon}
              />
            </div>
          ) : null}
        </td>
      </tr>
    );
  })
) : (
  <tr>
    <td colSpan="4">{showIntLoading ? <Loading/> : <strong className='flexRow justifyContentCenter alignItemsCenter'>{loadingMessage}</strong>}</td>
  </tr>
)}

            </tbody>
          </table>
        </div>
      </div>
    </div>
</div>

        </>

      }
{
       ( state && Boolean(state.selected) && (state.type ==='roles'|| state.type ==='rolesEdit') && state.selected.mode!=='remove' && state.selected.mode!=='removeResource') ? (
            <Modal
            className='cash-deposit-summary'
            title={``}
            TitleComponent={sectorTitle}
            mainContentCenter={true}
            showFieldsInColumn={true}
            customContentHeight={ModalContHeight}
            setIsDropdownOpen={setIsDropdownOpen}
            onClose={()=>onCloseEditMeals(state.type)}
            buttonLabel={'Save'}
            modalFormStatusObj={modalFormStatusObj}
            onSubmit={onSubmit}>
                <div className='flexCol justifyContentCenter alignItemsCenter'>

             { state.type!=='rolesEdit'?<div className=" dialog__container_item input-container">
              <div className={`dialog__description`}>
            <label  className={`sub-heading-title-req margBottom10 req`}>Role</label>
              <CustomSelect
                options={userRoles}
                isDisabled={state.selected.mode === 'edit'}
                width={'13rem'}
                value={userRoles?.find(function(option) {
                  return addRole && addRole?.value && addRole.value === option.value
                })}
                placeHolder=" Select Role"
                onChange={onAddRoleChange}
                />

            </div>
              </div>:null}


        <div className={`dialog__container_item input-container`}>
         <div className={`dialog__description`}>
            <label  className={`sub-heading-title-req margBottom10 req`}> Resources</label>
              <AllMultiSelect
              options={userResources}
              defaultValue={[]}
              isMulti
              styles={{
              ...customSelSearch(themedColor),
              option: (provided, state) => ({
              ...provided,
              width: '18rem',
              backgroundColor: state.isSelected
              ? themedColor.hover
              : state.isFocused
              ? themedColor.hover
              : themedColor.background,
              color: '#fff',
              cursor: 'pointer',
              '&:hover': {
              backgroundColor: themedColor.hover,
              },
              }),
              control: (defaultStyles) => ({
              ...defaultStyles,
              borderRadius: '3px',
              backgroundColor: themedColor.background,
              width: '12.8rem',
              boxShadow: 'none',
              }),
              placeholder: (defaultStyles) => ({
              ...defaultStyles,
              textAlign: 'left',
              }),
              }}
              isSearchable
              isClearable
              components={{ Option, MultiValue }}
              onMenuOpen={handleMenuOpen}
              onMenuClose={handleMenuClose}
              onChange={handleChangeRsources}
              allowSelectAll={true}
              value={state.selected.resourcesEdit}
              placeholder={`Select Resources`}
            />
      </div>
      </div>
      {state && state.descriptionItem.length && showDescription?<div style={{marginBottom:0,color:'#412b06'}} className='flexRow alignItemsCenter textAlignLeft sector-origin-m'>{state.descriptionItem}</div>:null}
     { state.type!=='rolesEdit'?<div className={`dialog__container_item input-container margBottom18`}>
         <div className={`dialog__description`}>
            <label  className={`sub-heading-title-req margBottom10 req`}> Actions</label>
        <AllMultiSelect
        options={userActions}
        defaultValue={[]}
        isMulti
        styles={{
          ...customSelSearch(themedColor),
          option: (provided, state) => ({
            ...provided,
            width: '18rem',
            backgroundColor: state.isSelected
              ? themedColor.hover
              : state.isFocused
              ? themedColor.hover
              : themedColor.background,
            color: '#fff',
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: themedColor.hover,
            },
          }),
          control: (defaultStyles) => ({
            ...defaultStyles,
            borderRadius: '3px',
            backgroundColor: themedColor.background,
            width: '12.8rem',
            boxShadow: 'none',
          }),
          placeholder: (defaultStyles) => ({
            ...defaultStyles,
            textAlign: 'left',
          }),
        }}
        isSearchable
        isClearable
        components={{ Option, MultiValue }}
        onChange={handleChangeActions}
        onMenuOpen={handleMenuOpen}
        onMenuClose={handleMenuClose}
        allowSelectAll={true}
        value={state.selected.actions}
        placeholder={`Select Actions`}

      />
      </div>
      </div>:null}


                </div>

        </Modal>
        )
        : null
      }


      {
       ( state && Boolean(state.selected) && state.type ==='viewResPermission'&& state.selected.data) ? (
          <Modal
      className="cash-deposit-summary"
      title=""
      TitleComponent={sectorTitle}
      mainContentCenter={true}
      showFieldsInColumn={true}
      showDone={true}
      disabled={actionEdit}
      customContentHeight={ModalContHeight}
      setIsDropdownOpen={setIsDropdownOpen}
      modalFormStatusObj={modalFormStatusObj}
      onClose={() => onCloseEditMeals('')}
      buttonLabel="Save"
      onSubmit={() => onCloseEditMeals(state.type)} 
    >
      <table id="rolesTable">
        <thead>
          <tr className="sticky" style={{ backgroundColor: themedColor.hover, color: '#fff' }}>
            <th>
              <div className="actions-row flexRow justifyContentSpaceAround">
                {state.selected.data.length
                  ? state.selected.data.map((item) => {
                      const actionKey = Object.keys(item)[0];
                      const actLabel =
                        userActions.find((act) => act.value === actionKey)?.label || actionKey;
                      return actLabel;
                    }).map((label, index) => (
                      <span key={index}>{label}</span>
                    ))
                  : null}
              </div>
            </th>
          </tr>
        </thead>

<tbody>
  <tr>
    <td colSpan={1}>
      <div className="flexRow justifyContentSpaceAround margBottm20 margTop16">
        {state.selected.data.length ? (
          state.selected.data.map((item, index) => {
            const actionKey = Object.keys(item)[0];
            const isChecked = selectedActions[actionKey] ?? Object.values(item)[0];

            return (
              <div key={index} className="inlBlock">
                <div className="action-checkbox">
                  <div className="width100 dialog__description__checkbox">
                    <input
                      type="checkbox"
                      checked={isChecked}
                      onChange={(e) =>
                        handleCheckboxChange(actionKey, e.target.checked)
                      }
                    />
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <strong>No actions available</strong>
        )}
      </div>
    </td>
  </tr>
</tbody>


      </table>
    </Modal>
        )
        : null
      }

      {
        state && Boolean(state.selected2) && state.type ==='roleAdd' ? (
          <EditModal
            key={state.selected.type}
            title={"Add Role"}
            disabled={disabledAction}
            onClose={()=>onCloseEditMeals(state.type)}
            showFieldsInColumn={true}
            buttonLabel={'Save'}
            customContentHeight={ModalContHeight}
            setIsDropdownOpen={setIsDropdownOpen}
            modalFormStatusObj={modalFormStatusObj}
            onSubmit={onSubmitNewRoles}
            onChange = {onFieldChangeHandler}

            fields={state.type==='roleAdd'?editFieldsRolesPerm.map((_) => {
              return { ..._, initialValue: state.selected[_.attribute] }
            }):editFieldsInt.map((_) => {
              return { ..._, initialValue: state.selected[_.attribute] }
            })}
          />
        )
        : null
      }
      {
        state && Boolean(state.selected) && state.type ==='userRolePerm' ? (
          <EditModal
            key={state.selected.type}
            title={"Edit User Role & Permission"}
            onClose={()=>onCloseEditMeals('userRolePerm')}
            customContentHeight={ModalContHeight}
            setIsDropdownOpen={setIsDropdownOpen}
            showFieldsInColumn={true}
            buttonLabel={'Save'}
            onSubmit={()=>onCloseEditMeals('userRolePerm')}
            onChange = {onFieldChangeHandler}
            fields={editFieldsRolesUserPerm.map((_) => {
              return { ..._, initialValue: null }
            })}
          />
        )
        : null
      }
      {
        state?.type==='allow/deny' && Boolean(state?.selected) ? (
          <EditModal
            key={state.selected.type}
            title={ modalTitle }
            onClose={()=>onCloseEditMeals(state?.type)}
            mainContentCenter={true}
            customContentHeight={ModalContHeight}
            setIsDropdownOpen={setIsDropdownOpen}
            modalFormStatusObj={modalFormStatusObj}
            onSubmit={()=>onCloseEditMeals(state?.type)}
            modalCustomButtons={modalCustomButtons}
            fields={editFieldsCess.map( (elt) => {
              return { ...elt, initialValue:state.selected[elt.attribute] }
              })
            }
          />
        )
        : null
      }
         {state && Boolean(state.selected) && state.selected.mode==='removeResource' && <DeleteConf  {...delPropRes} modalFormStatusObj={modalFormStatusObj} description={`Are you sure you want to remove ${typeof state?.selected?.name === 'string' ? state?.selected?.name : ''}  resource from ${typeof state?.selected?.roleName === 'string' ? state?.selected?.roleName : ''} ?`} />}
   {state && Boolean(state.selected) && state.selected.mode==='remove' && <DeleteConf  {...delProps} modalFormStatusObj={modalFormStatusObj} description={`Are you sure you want to delete ${typeof state?.selected?.role==='string'?state?.selected?.role:state?.selected?.role.name} ?`} />}
        {
        !ready &&<div className='overlay_hide sub'></div>
      }
    </div>
  )
}